function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { path } from 'ramda';
import { stateGo } from 'redux-ui-router';
import { i18n, MetadataActions, MetadataConstants, MetadataSelectors, SessionSelectors } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../../../../locales/keys';
import { CurrentCustomerIdSelector } from '../../../../../../../reducers/selectors/customer.selectors';
import * as EwalletSelector from '../../../../../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../../../../../reducers/selectors/customer.household.selectors';
import { CurrentRemovalSelector, CurrentSubscriptionIdSelector, RemoveSubscriptionNameSelector, CurrentSubscriptionSelector, IsFetchingDataSelector, UserCanIssueCreditToAlternatePaymentInstrument } from '../../../../../../../reducers/selectors/customer.subscriptions.selectors';
import { CurrentSubscriptionItemWithExtensionSelectors, CurrentSubscriptionItemExtensionSelectors, CurrentSubscriptionItemExtensionPricingPlanSelectors } from '../../../../../../../reducers/selectors/customer.subscriptions.products.selectors';
import { CurrencySelector, IsSubmittingOrderSelector, LastAttemptErrorSelector } from '../../../../../../../reducers/selectors/offering.remove.selectors';
import { retrieveSubscription } from '../../../../../../../reducers/actions/customer.subscriptions.actions';
import { retrieveWallet, selectPaymentMethod } from '../../../../../../../reducers/actions/customer.ewallet.actions';
import { submitChangeOfServiceOrderRemoval } from '../../../../../../../reducers/actions/offering.remove.actions';
import * as SubscriptionConstants from '../../../../../../shared/constants/subscriptions.constants';
import { NOTIFICATION_TIME_LENGTH } from '../../../../../../../customercare.constants';
import { SUBSCRIPTION_DETAILS_ROUTE } from '../../../../subscriptions.config';
import { DASHBOARD_ROUTE } from '../../../../../../../reducers/constants/dashboard.constants';
var CREDIT_AMOUNT_TYPE = {
  MAX: 'MAX',
  CUSTOM: 'CUSTOM'
};
var RemoveExtensionConfirmationController = /*#__PURE__*/function () {
  function RemoveExtensionConfirmationController($ngRedux, $q, $filter, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, RemoveExtensionConfirmationController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $q: $q,
      $filter: $filter,
      CreditAmountType: CREDIT_AMOUNT_TYPE,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      uiNotificationService: uiNotificationService
    });
    this.confirmationPopup = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.confirmationPopup.api = api;
      }
    };
    this.removal = {
      creditAmount: 0,
      creditAmountType: CREDIT_AMOUNT_TYPE.MAX,
      creditReason: null,
      customAmount: 0,
      errors: [],
      sendNotification: true,
      terminationReason: null
    };
    this.onConfirmation = this.onConfirmation.bind(this);
  }
  return _createClass(RemoveExtensionConfirmationController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          canIssueCreditToAlternatePaymentMethod: UserCanIssueCreditToAlternatePaymentInstrument(store),
          creditReasons: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.CreditReasons, store),
          creditReasonsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CreditReasons, store),
          currency: CurrencySelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
          currentRemoval: CurrentRemovalSelector(store),
          currentSubscription: CurrentSubscriptionSelector(store),
          currentSubscriptionItem: CurrentSubscriptionItemWithExtensionSelectors(store),
          currentSubscriptionItemExtension: CurrentSubscriptionItemExtensionSelectors(store),
          currentSubscriptionItemExtensionPricingPlan: CurrentSubscriptionItemExtensionPricingPlanSelectors(store),
          eWalletError: EwalletSelector.EwalletErrorSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isFetchingEwalletData: EwalletSelector.IsRetrievingEwalletDataSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          language: SessionSelectors.LanguageSelector(store),
          lastAttemptError: LastAttemptErrorSelector(store),
          lastRoute: SessionSelectors.LastRouteSelector(store),
          subscriptionId: CurrentSubscriptionIdSelector(store),
          paymentInstruments: EwalletSelector.PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          subscriptionName: RemoveSubscriptionNameSelector(store),
          subscriptionTerminationReasons: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.SubscriptionTerminationReason, store),
          subscriptionTerminationLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.SubscriptionTerminationReason, store),
          selectedPaymentMethod: EwalletSelector.SelectedPaymentMethodSelector(store),
          userHasEWalletAdminAccess: EwalletSelector.UserHasEWalletAdminAccess(store),
          waiveFeeReasons: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.WaiveFeeReason, store),
          waiveFeeReasonsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.WaiveFeeReason, store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        retrieveSubscription: retrieveSubscription,
        retrieveWallet: retrieveWallet,
        selectPaymentMethod: selectPaymentMethod,
        submitChangeOfServiceOrderRemoval: submitChangeOfServiceOrderRemoval,
        stateGo: stateGo
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      if (!this.state.subscriptionTerminationLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.SubscriptionTerminationReason);
      }
      if (!this.state.creditReasonsLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.CreditReasons);
      }
      this.$q.all([this.actions.retrieveSubscription(this.state.currentCustomerId, {
        Id: this.state.subscriptionId,
        IncludeChangeOptions: true
      }), this.actions.retrieveWallet({
        customerId: this.state.currentCustomerId
      })]).then(function () {
        return _this2.actions.selectPaymentMethod(_this2.state.currentSubscription.PaymentInstrument);
      }).then(function () {
        _this2.removal.creditAmount = _this2.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount;
      }).catch(function () {
        var message = path(['eWalletError', 'message'], _this2.state) || path(['subscriptionError', 'message'], _this2.state);
        if (message) {
          _this2.uiNotificationService.transientError(message);
        }
      });
    }
  }, {
    key: "handleSetEffectiveType",
    value: function handleSetEffectiveType() {
      this.removal.creditAmount = 0;
      this.removal.creditAmountType = CREDIT_AMOUNT_TYPE.MAX;
      this.removal.customAmount = 0;
    }
  }, {
    key: "isCurrentPaymentMethodRemoved",
    value: function isCurrentPaymentMethodRemoved() {
      if (!this.state.selectedPaymentMethod) {
        return false;
      }
      return this.state.selectedPaymentMethod.Status === SubscriptionConstants.PAYMENT_METHOD_STATUSES.REMOVED;
    }
  }, {
    key: "confirmRemoval",
    value: function confirmRemoval() {
      if (this.removeExtensionForm.$valid && this.isAmountValid) {
        this.confirmationPopup.api.open();
      }
    }
  }, {
    key: "closeConfirmation",
    value: function closeConfirmation() {
      this.confirmationPopup.api.close();
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(confirmed) {
      if (confirmed) {
        this.removeExtensionForm.$setPristine();
        this.removeExtension();
      }
      this.confirmationPopup.api.close();
    }
  }, {
    key: "showCreditOptions",
    value: function showCreditOptions() {
      return this.state.currentSubscriptionItemExtensionPricingPlan ? !!this.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount : false;
    }
  }, {
    key: "createRequest",
    value: function createRequest() {
      var removeExtensionRequest = {
        CreditAmount: this.removal.creditAmount,
        CreditPaymentInstrument: this.state.selectedPaymentMethod,
        CreditPaymentInstrumentId: this.state.selectedPaymentMethod.Id,
        CreditReason: this.removal.creditReason,
        RemoveReasonCode: this.removal.terminationReason,
        RemoveItems: [{
          LockerItemId: parseInt(this.state.currentSubscriptionItem.Id),
          PricingPlanId: this.state.currentSubscriptionItemExtension.PricingPlanId,
          ProductId: this.state.currentSubscriptionItemExtensionPricingPlan ? this.state.currentSubscriptionItemExtensionPricingPlan.ProductId : null,
          SubscriptionExtensionId: parseInt(this.state.currentSubscriptionItemExtension.Id)
        }],
        SendNotification: this.removal.sendNotification,
        SubscriptionId: this.state.subscriptionId,
        UseDefaults: true
      };
      return removeExtensionRequest;
    }
  }, {
    key: "removeExtension",
    value: function removeExtension() {
      var _this3 = this;
      this.actions.submitChangeOfServiceOrderRemoval(this.createRequest(), this.state.currentCustomerId).then(function () {
        _this3.uiNotificationService.success(i18n.translate(_this3.CustomerCareLocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.REMOVE_SUCCESS), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        if (_this3.state.lastRoute.name === SUBSCRIPTION_DETAILS_ROUTE) {
          _this3.actions.stateGo(SUBSCRIPTION_DETAILS_ROUTE, {
            'subscriptionId': _this3.state.currentSubscription.Id
          });
        } else {
          _this3.actions.stateGo(DASHBOARD_ROUTE, {
            'customerId': _this3.state.currentCustomerId
          });
        }
      }).catch(function () {
        _this3.uiNotificationService.error(_this3.state.lastAttemptError.message, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "isAmountValid",
    get: function get() {
      var value = parseFloat(this.removal.creditAmount);
      var max = this.state.currentSubscriptionItemExtensionPricingPlan ? this.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount : value;
      return value >= 0 && value <= max;
    }
  }, {
    key: "handleSetCreditAmount",
    value: function handleSetCreditAmount() {
      if (this.removal.creditAmountType === CREDIT_AMOUNT_TYPE.MAX) {
        this.removal.customAmount = 0;
        this.removal.creditAmount = this.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount;
        this.removeExtensionForm.creditCustomAmount.$setUntouched();
        this.removeExtensionForm.creditCustomAmount.$validate();
        if (!this.removeExtensionForm.creditCustomAmount.$invalid) {
          this.removal.errors = [];
        }
      } else if (this.removal.creditAmountType === CREDIT_AMOUNT_TYPE.CUSTOM) {
        this.removal.creditAmount = this.removal.customAmount || 0;
        this.removeExtensionForm.creditCustomAmount.$validate();
        if (this.removeExtensionForm.creditCustomAmount.$invalid) {
          this.removal.errors = [this.creditMinMaxAmount];
        }
      }
    }
  }, {
    key: "updateCustomAmount",
    value: function updateCustomAmount() {
      this.removal.creditAmount = this.removal.customAmount || 0;
      if (this.removeExtensionForm.creditCustomAmount.$invalid) {
        this.removal.errors = [this.creditMinMaxAmount];
      } else {
        this.removal.errors = [];
      }
    }
  }, {
    key: "amountValueInvalid",
    get: function get() {
      return i18n.translate(this.CustomerCareLocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.MAX_AMOUNT, {
        maxAmount: this.$filter('invCurrency')(this.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount, this.state.currency)
      });
    }
  }, {
    key: "canCreatePaymentInstruments",
    get: function get() {
      return this.state.currentMemberCanCreatePaymentInstrument && this.state.userHasEWalletAdminAccess;
    }
  }, {
    key: "creditMinMaxAmount",
    get: function get() {
      var max = this.state.currentSubscriptionItemExtensionPricingPlan ? this.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount : null;
      return i18n.translate(this.CustomerCareLocaleKeys.REMOVE_OFFER.AMOUNT_VALUE_INVALID, {
        minAmount: this.$filter('invCurrency')(0, this.state.currency),
        maxAmount: this.$filter('invCurrency')(max, this.state.currency)
      });
    }
  }, {
    key: "customAmountIsError",
    get: function get() {
      return (this.removeExtensionForm.creditCustomAmount.$touched || this.removeExtensionForm.$submitted) && !this.isAmountValid && this.removal.creditAmountType === this.CreditAmountType.CUSTOM;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.state.isFetchingData || this.state.isFetchingEwalletData || this.state.isSubmittingOrder;
    }
  }, {
    key: "maxAmount",
    get: function get() {
      var max = this.state.currentSubscriptionItemExtensionPricingPlan ? this.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount : null;
      return i18n.translate(this.CustomerCareLocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.MAX_AMOUNT, {
        maxAmount: this.$filter('invCurrency')(max, this.state.currency)
      });
    }
  }, {
    key: "pricingPlanTitle",
    get: function get() {
      return i18n.translate(this.CustomerCareLocaleKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.REMOVE_PRICING_PLAN, {
        pricingPlanName: this.state.currentSubscriptionItemExtensionPricingPlan ? this.state.currentSubscriptionItemExtensionPricingPlan.Name : null
      });
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this4 = this;
      this.removeExtensionForm.creditCustomAmount.$validators.isCreditAmountValid = function (modelValue, viewValue) {
        var value = parseFloat(modelValue || viewValue);
        var max = _this4.state.currentSubscriptionItemExtensionPricingPlan ? _this4.state.currentSubscriptionItemExtensionPricingPlan.ChargeAmount : value;
        return value >= 0 && value <= max || _this4.removal.creditAmountType === CREDIT_AMOUNT_TYPE.MAX;
      };
    }
  }]);
}();
export default {
  template: require('./remove.extension.confirmation.template.html'),
  controller: RemoveExtensionConfirmationController
};